import useReplayImportTask from "@babackapp/private-api-client/client/use-replay-import-task";
import type { ShopDto, TaskDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@babackapp/ui/components/alert-dialog";

interface ReplayTaskAlertDialogProps {
  task: TaskDto;
  shop: ShopDto;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export default function ReplayTaskAlertDialog({
  task,
  shop,
  isOpen,
  onOpenChange,
}: ReplayTaskAlertDialogProps) {
  const t = useTranslation();
  const { mutateAsync: replayTask, isPending } = useReplayImportTask(shop);

  const handleReplay = async () => {
    await replayTask({
      importId: task.jobId,
      taskId: task.id,
    });
    onOpenChange(false);
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("misc.areYouSure")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("settings.integrations.imports.rerun")} — {task.input.file?.name}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>
            {t("misc.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleReplay} disabled={isPending}>
            {t("misc.continue")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
